module.exports = __webpack_public_path__ + "media/images/redesign-images/backgrounds/bg-wood-pattern-a40ad4e4f3df1592b0cacd18427675e9.svg";